<div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">

    <div class="ps-3">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0 p-0">
                <li class="breadcrumb-item"><a href="javascript:;"><i class="bx bx-home-alt"></i></a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">Report</li>
            </ol>
        </nav>
    </div>

</div>
<!--end breadcrumb-->

<div class="card">
    <div class="card-body">
        <div class="d-flex align-items-center">
            <h5 class="mb-0">MONTHLY REPORT</h5>
            <form class="ms-auto position-relative">
                <div class="position-absolute top-50 translate-middle-y search-icon px-3"><i class="bi bi-search"></i></div>
                <input class="form-control ps-5" type="text" placeholder="search">
            </form>
        </div><br />

        <div class="row" style="overflow-x: auto">
            <table class="table">
                    <thead class="table-secondary">
                        <tr>
                            <th *ngFor="let item of headers">{{item}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of rowValue;index as i">
                            <td *ngFor="let col of item._rawData">
                                {{ col }}
                            </td>
                        </tr>
                    </tbody>
            </table>
        </div>
    </div>
</div>